/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'policy-grid-menu-tooltip-controller';
const prefix = `${moduleName}.${componentName}`;

export const editLabel = `${prefix}.editLabel`;
export const moveToLabel = `${prefix}.moveToLabel`;
export const duplicateRuleLabel = `${prefix}.duplicateRuleLabel`;

export const ENGLISH = {
    [editLabel]: 'Edit',
    [moveToLabel]: 'Move to',
    [duplicateRuleLabel]: 'Duplicate rule',
};
